module.exports = __webpack_public_path__ + "static/media/mixed_Arrow.b1c1581f.gif";